var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingHeroVector1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 304,
    viewBox: "0 0 1440 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1871 323.63C1538.77 382.172 1436.28 87.9338 1109.55 126.113C1008.6 137.911 992.161 149.465 806 211.682C616 275.182 316.166 277.823 124.5 186.79C-84.4021 87.5713 -40.8551 -35.8763 -85.5 9.79004L-110 965.682H1871V323.63Z",
    fill: "#E5EDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingHeroVector1);
export default __webpack_public_path__ + "static/media/trainingHeroVector1.31c296f6e2a2bbc2689aef0845a7d784.svg";
export { ForwardRef as ReactComponent };